import {createClient} from '@supabase/supabase-js';

export const supabase = createClient(
    "https://ppdnxocptskhefyyvqzi.supabase.co",
     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBwZG54b2NwdHNraGVmeXl2cXppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYwNDUwMjAsImV4cCI6MjA3MTYyMTAyMH0.I4qnssbLhc7PIjJadYTU_V5nAn4cMpMC92fdIZe4b7E"
    );

